import React, { useState, useEffect } from 'react';
import './Contact.css';import { httpsCallable } from "firebase/functions";
// import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import logo from '../Images/Logo_Invis.png';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer'
import contactImage1 from '../Images/Services/Yacht Clearances _ Customs & Immigration.jpg';
import contactImage2 from '../Images/Services/Parts Shipping and Logistics _ Yacht & Container Shipping _ Race Yacht Support.jpg';
import contactImage3 from '../Images/Services/Provisioning.jpg';
import contactImage4 from '../Images/Services/Concierge Services _ Flight Bookings _ VIP Transport.png';


const contactImages = [
  { src: contactImage1, alt: 'Yacht clearances and customs services' },
  { src: contactImage2, alt: 'Yacht shipping and logistics services' },
  { src: contactImage3, alt: 'Yacht provisioning services' },
  { src: contactImage4, alt: 'Concierge services and VIP transport' },
];

function Contact() {
  // Forms
  const [form, setForm] = useState({
      name: "",
      email: "",
      phone: "",
      message: ""
    });
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setStatus("");

      try {
        const sendContactEmail = httpsCallable(functions, "sendContactEmail");
        await sendContactEmail(form);
        setStatus("Thanks! We’ll be in touch shortly.");
        setForm({ name: "", email: "", phone: "", message: "" });
      } catch (err) {
        console.error(err);
        setStatus("Something went wrong. Please try again.");
      }

      setLoading(false);
    };


  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousIndex(currentIndex);
      setCurrentIndex((prev) => (prev + 1) % contactImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <>
      {/* Navbar */}
      {/* <nav className="navbarC">
        <div className="menu-toggle">☰</div>
      </nav> */}
      <Navbar/>

      {/* Slideshow */}
      <div className="contact-slideshow">
        {contactImages.map(({ src, alt }, i) => {
          let className = 'contact-slide';
          if (i === currentIndex) className += ' slide-in';
          else if (i === previousIndex) className += ' slide-out';
          return (
            <img key={src} src={src} alt={alt} className={className} />
          );
        })}
      </div>

      {/* Contact Content */}
      <main className="contact-container">
        {/* Left Column */}
        <div className="contact-left">
          <p className="contact-subtitle">GET IN TOUCH TODAY</p>
          <h2 className="contact-title">Contact <em>Us</em></h2>
          <p className="contact-description">
             Contact our team for further guidance. Our team is here to help with any questions or concerns you may have.
          </p>
          <ul className="contact-details">
            <li><strong>📍</strong> English Harbour, Antigua and Barbuda</li>
            <li><strong>✉ </strong>   info@captainsconnections.com</li>
          </ul>
        </div>

        {/* Right Column */}
        <div className="contact-right">
          <form className="contact-form">
            <label>Full Name *</label>
            <input type="text" placeholder="Your full name" />

            <label>Email *</label>
            <input type="email" placeholder="Your email address" />

            <label>Phone</label>
            <input type="tel" placeholder="Your phone here" />

            <label>Your Message</label>
            <textarea placeholder="Your message here" />

            <div className="services-checklist">
              <p>I am interested in the following services:</p>
              {[
                'Yacht Clearances', 'Customs & Immigrations', 'Provisioning',
                'Shipping Logistics', 'Concierge Services & Shore Updates', 
              ].map((service, i) => (
                <label key={i}>
                  <input type="checkbox" />
                  {service}
                </label>
              ))}
            </div>

            <div className="terms">
              <label>
                <input type="checkbox" />
                I agree to the Terms and conditions and Privacy Policy
              </label>
            </div>

            <button type="submit" className="submit-button"  disabled={loading}>Get in Touch</button>
          </form>
        </div>
      </main>

      {/* Footer
      <footer className="site-footer">
        <div className="footer-nav">
          <a href="/services">Our Services In Antigua</a>
          <a href="/destinations-and-itineraries">Destinations & Itinerary</a>
          <a href="/connect">Connect With Services</a>
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="footer-contact">
            <h4>Get In Touch</h4>
            <p>Feel free to <a href="/contact">Contact Us</a>.</p>
          </div>
          <a href="/">
            <img src={logo} alt="Captain’s Connections Logo" className="footer-logo-image" />
          </a>
        </div>
      </footer> */}
      <Footer/>
    </>
  );
}

export default Contact;
